import { http } from '../axios';
import { globalError } from '../../shared/notification/actions';
import Keycloak from 'keycloak-js';
import { AxiosError, AxiosRequestConfig } from 'axios';

function createKcConfig(kc: Keycloak): AxiosRequestConfig {
    return {
        external: true, // FIXME: does not exist in axios config
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${kc.token}`
        }
    };
}

export type User = { id: string; username: string };

export const findUsers = async ({ searchString, kc }: { searchString: string; kc: Keycloak }) => {
    const config = createKcConfig(kc);
    config.params = {
        search: searchString,
        first: 0,
        max: 50
    };

    try {
        return (await http.get<User[]>(`${kc.authServerUrl}/admin/realms/${kc.realm}/users`, config)).data;
    } catch (error) {
        if (error instanceof AxiosError) {
            globalError(error);
        }
    }
};

export const impersonateUser = async ({ userId, kc }: { userId: string; kc: Keycloak }) => {
    const config = createKcConfig(kc);

    try {
        await http.post(`${kc.authServerUrl}/admin/realms/${kc.realm}/users/${userId}/impersonation`, '', config);
    } catch (error) {
        if (error instanceof AxiosError) {
            globalError(error);
        }
    }
};
